var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColoredList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4461",
    "data-name": "Group 4461",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.836,
    height: 12.814,
    viewBox: "0 0 12.836 12.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3010",
    "data-name": "Rectangle 3010",
    width: 12.835,
    height: 12.814,
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4449",
    "data-name": "Group 4449",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18153",
    "data-name": "Path 18153",
    d: "M6.415,12.085a5.679,5.679,0,0,0,5.5-7.067.364.364,0,0,1,.261-.487c.222-.055.38.055.45.313A6.4,6.4,0,1,1,9.169.621c.043.02.087.042.128.066.221.127.293.308.2.5a.392.392,0,0,1-.538.153A11.8,11.8,0,0,0,7.835.923,5.671,5.671,0,0,0,4.372,11.7a5.409,5.409,0,0,0,2.042.381",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18154",
    "data-name": "Path 18154",
    d: "M85.628,30.328,89.06,26.89l2.228-2.228a1.87,1.87,0,0,1,.156-.149.361.361,0,0,1,.515.5,1.928,1.928,0,0,1-.18.193l-5.733,5.731c-.349.349-.477.348-.83,0L83.651,29.37c-.028-.028-.058-.056-.085-.086a.375.375,0,0,1-.032-.554.366.366,0,0,1,.553.039c.456.451.909.905,1.362,1.359.056.056.106.118.178.2",
    transform: "translate(-79.414 -23.243)",
    fill: "#ee2c3c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredList);
export default __webpack_public_path__ + "static/media/colored-list.690de6f47876d17c75b6c796f2fa7bea.svg";
export { ForwardRef as ReactComponent };